import settings from './settings/reducer';
import { combineReducers } from 'redux';

import selectorsReducer from "./reducers/selectorsReducer"
import indexedReducer from "./reducers/indexedReducer";
import langsReducer from "./reducers/langsReducer";
import genericReducer from "./reducers/genericReducer";
import filterReducer from "./reducers/filterReducer";
import mainReducer from "./reducers/mainReducer";
import formReducer from "./reducers/formReducer";
import listReducer from "./reducers/listReducer";
import subFormReducer from "./reducers/subFormReducer";

const reducers = combineReducers({
    settings,
    langs       :   langsReducer,
    genericInfo :   genericReducer,
    filter      : filterReducer,

    indexedProps : indexedReducer,
    mainProps   : mainReducer,
    formProps   : formReducer,
    listProps   : listReducer,
    subFormProps: subFormReducer,
    selectors   : selectorsReducer
});

export default reducers;